const APPID = "JHA-217";

function retry(fn, count = 60, delay = 1000) {
  try {
    return fn();
  } catch (error) {
    if (count <= 0) {
      console.error(error);
      return;
    }
    setTimeout(() => {
      retry(fn, count - 1, delay);
    }, delay);
  }
}

export function getTraceId() {
  let str = sessionStorage.getItem(`${APPID}_traceId`);
  if (str) return str;
  str =
    Math.random()
      .toString()
      .substr(2, 36) + Date.now().toString(36);
  sessionStorage.setItem(`${APPID}_traceId`, str);
  return str;
}

export function landingPageView(vm, opts = {}) {
  const data = {
    landing_page_id: opts.landing_page_id || `${APPID}${vm.version ? `_${vm.version}` : ''}`,
  };
  return retry(() => window.LandingSDK.track.landingPageView(data), opts.retryCount);
}

export function landingPageClick(vm, opts = {}) {
  const screenW = window.screen ? window.screen.width : opts.screen_width || 0;
  const screenH = window.screen ? window.screen.height : opts.screen_height || 0;
  const data = {
    landing_page_id: opts.landing_page_id || `${APPID}${vm.version ? `_${vm.version}` : ''}`,
    tab_key: opts.tab_key || "",
    tab_name: opts.tab_name || "",
    click_coordinates_x: opts.click_coordinates_x || 0,
    click_coordinates_y: opts.click_coordinates_y || 0,
    click_x_percent:
      typeof opts.click_x_percent === "number"
        ? opts.click_x_percent
        : Math.round(((opts.click_coordinates_x || 0) / (screenW || 1)) * 100),
    click_y_percent:
      typeof opts.click_y_percent === "number"
        ? opts.click_y_percent
        : Math.round(((opts.click_coordinates_y || 0) / (screenH || 1)) * 100),
    screen_width: screenW,
    screen_height: screenH,
    trace_id: opts.trace_id || getTraceId(),
  };
  return retry(() => window.LandingSDK.track.landingPageClick(data), opts.retryCount);
}
